import { TableArrowDownIcon } from './TableArrowDownIcon';

/**
 * author: Michael Irigoyen
 * id 846F0539-E30D-40E8-BC00-3F10A0C0321E
 * name table-arrow-down
 * version: 5.1.45
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/table-arrow-down.svg
 * tags
 */
export const TableDownloadIcon = TableArrowDownIcon;
export default TableDownloadIcon